export default __webpack_public_path__ + "static/media/htx.c1c5378b.png";